import { render } from "./CompanyOrders.vue?vue&type=template&id=18f75cf0&scoped=true"
import script from "./CompanyOrders.vue?vue&type=script&lang=js"
export * from "./CompanyOrders.vue?vue&type=script&lang=js"

import "./CompanyOrders.vue?vue&type=style&index=0&id=18f75cf0&scoped=true&lang=css"

import exportComponent from "/var/www/html/projects/hetfruit/resources/vueapps/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f75cf0"]])

export default __exports__